import { font } from 'modules/styles';
import styled from 'styled-components';

export const Container = styled.div`
    ${font(13, '#7f7d7d')}
`;
